import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
//import axios from "axios";
import {HTTP} from './http-const';

//import SocketIO from "socket.io-client"


//import router from './router';
//import qs from 'qs';

// eslint-disable-next-line no-unused-vars
import remoteSys from './modules/remoteSys.store'




import authHeader from './services/auth-header';

Vue.use(Vuex);


const vuexPersist = new VuexPersist({
    key: 'trustx++',
    storage: window.sessionStorage,
});

export default new Vuex.Store({
    modules: {
        remoteSys:     [],      // remote systems are retrieved from server (backend) and kept in this array
    },

    state: {
        messages: [],
        token   : '',
        user    : 'Stranger',

        selectedOperation: 0,

        // text displayed on the remote device
        remoteText : 'Could not connect to backend...',
        remoteText_color: '#00FF00',                            // color given as hex value, as used by UI various components
        remoteText_r : 0,
        remoteText_g : 255,
        remoteText_b : 0,

    },

    create() {
        localStorage.clear('token');
        localStorage.clear('user');
        sessionStorage.clear('trustx++');        
    },

    mutations: {
        updateMessages(state, messages) {
            state.messages = messages;
        },

        // appends the message at the top of the log (as seen on screen)
        // this is called when the server notifies the client (via socket.io emit call) 
        // see SOCKET_newMessages(...) action below
        appendMessage(state, message) {                     
            state.messages.unshift(message);
        },

        clearLogM(state) {
            state.messages = [];
        },


        IoTstateChanged(state, msg) {
//            if (msg.name == remoteSys[0].name)
            if (0 == msg.state.localeCompare("connected")) {
                state.remoteSys[0].connected = true;
                state.remoteSys[1].connected = true;
            }
            else {
                state.remoteSys[0].connected = false;
                state.remoteSys[1].connected = false;
            }
        },


        updateRemoteSystemList(state, rsList) {
            state.remoteSys = rsList;
        },

        updateRemoteContent(state, content) {
            state.remoteText = content.text;
            state.remoteText_color = content.color;
        },

        newMessage(state, message) {
            state.messages.push(message);
        },

        login(state, t) {
            state.token = t.token;
            state.user = t.user;
        },

        logout(state) {
            state.token = '';
            state.user = '';
        },


        // the following are needed only for updating the state, which in turn insures proper display of the 
        // current operation in the middle part of UI
        forceReset(state) {
            state.selectedOperation = 1;
        },

        checkIntegrity(state) {
            state.selectedOperation = 0;
        },

        autoPolicy(state) {
            state.selectedOperation = 2;
        },

        remoteSystemDetails(state) {
            state.selectedOperation = 3;
        },

    },

    actions: {
      async login({ commit }, registerData) {
            await HTTP.post("/api/login", registerData).then( response => {
                commit("login", { user: response.data.user, token: response.data.token });
                return Promise.resolve();
            }).catch(e => {        
                return Promise.reject(e);
            });
      },

      async logout({commit}) {
          commit("logout");
      },

      async getLogMessages({ commit }) {
        let messages = (await HTTP.get("/api/logMessages", { headers: authHeader() })).data
        commit('updateMessages', messages);
      },


      async getRemoteSystemList({commit}) {
        let rsList = (await HTTP.get("/api/remoteSystems", { headers: authHeader() })).data
        commit('updateRemoteSystemList', rsList);
      },


      // triggered from server side for each new log message inserted
      // always only 1 message is coming in. this limits the traffic, keeps app fast; drawback - on the
      // UI there might be more than 36 messages accumulated, while the servers keeps latest 36 messages only
      async SOCKET_NewMessages({commit}, msg) {
//          commit('appendMessage', msg);
          console.log('msg recvd: ' + msg);
        let messages = (await HTTP.get("/api/logMessages", { headers: authHeader() })).data
        commit('updateMessages', messages);

      },

    //   SOCKET_connect({commit}) {
    //       console.log('socket connected?!');
    //   },

    //   SOCKET_reconnectAttempt({commit}) {
    //     console.log('socket reconnect?!');
    // },

      // triggered by server when an IoT device is connected/disconnected
      // msg contains the IoT device name and the state
      async SOCKET_IoTstateChanged({commit}) {
        let rsList = (await HTTP.get("/api/remoteSystems", { headers: authHeader() })).data
        commit('updateRemoteSystemList', rsList);
//        commit('IoTstateChanged', msg);
        console.log('state chnaged');
      },

      clearLog({commit}) {
          commit('clearLogM');
      },

      // ####################################################################################################################
      //
      //  BEGIN - app control center API
      //
      // ####################################################################################################################

      async getRemoteContent({ commit }) {
        let content = (await HTTP.get("/api/getRemoteContent")).data
        commit('updateRemoteContent', content);
      },      

      async setRemoteContent({ commit }, content) {         // content = { color: '#xxxxxx', text: '...'}
        await HTTP.post("/api/setRemoteContent", content, { headers: authHeader() }).then( response => {
            commit('updateRemoteContent', response.data); //  { color: response.data.color, text: response.data.text });
            return Promise.resolve();
        }).catch(e => {
            return Promise.reject(e);
        })
      },      
    
      // ####################################################################################################################
      //
      // END - app control center API
      //
      // ####################################################################################################################



      

      // ####################################################################################################################
      //
      //  BEGIN - remote IoT control API
      //
      // ####################################################################################################################


      async forceReset({commit}, devId) {
        commit('forceReset');
        await HTTP.post('/api/forceReset', {deviceID: devId}, { headers: authHeader()});
      },


      async checkIntegrity({commit}, devID) {
        commit('checkIntegrity');
        console.log(devID);
        await HTTP.post('/api/checkIntegrity', {deviceID: devID}, { headers: authHeader()});
        // if device online proceed with sending command to server and waiting for answer
        // else return pop-up message: device offline
      },



      // ####################################################################################################################
      //
      //  END - remote IoT control API
      //
      // ####################################################################################################################



    },





    plugins: [vuexPersist.plugin]
})
